import { FastSinglelist } from "../../../utils/SingletonList";
import { ShaderDefines2D } from "../../../webgl/shader/d2/ShaderDefines2D";
import { WebDefineDatas } from "../../RenderModuleData/WebModuleData/WebDefineDatas";
import { WebGLEngine } from "../RenderDevice/WebGLEngine";
export class WebGLRenderElement2D {
    constructor() {
        this.renderStateIsBySprite = true;
        this.type = 0;
        this._shaderInstances = new FastSinglelist();
    }
    _compileShader(context) {
        var passes = this.subShader._passes;
        this._shaderInstances.clear();
        for (var j = 0, m = passes.length; j < m; j++) {
            var pass = passes[j];
            if (pass.pipelineMode !== context.pipelineMode)
                continue;
            var comDef = WebGLRenderElement2D._compileDefine;
            if (this.globalShaderData) {
                this.globalShaderData._defineDatas.cloneTo(comDef);
            }
            else {
                context._globalConfigShaderData.cloneTo(comDef);
            }
            if (context.passData) {
                comDef.addDefineDatas(context.passData._defineDatas);
            }
            let returnGamma = !(context._destRT) || ((context._destRT)._textures[0].gammaCorrection != 1);
            if (returnGamma) {
                comDef.add(ShaderDefines2D.GAMMASPACE);
            }
            else {
                comDef.remove(ShaderDefines2D.GAMMASPACE);
            }
            if (context.invertY) {
                comDef.add(ShaderDefines2D.INVERTY);
            }
            else {
                comDef.remove(ShaderDefines2D.INVERTY);
            }
            if (this.value2DShaderData) {
                comDef.addDefineDatas(this.value2DShaderData.getDefineData());
                pass.nodeCommonMap = this.nodeCommonMap;
            }
            if (this.materialShaderData)
                comDef.addDefineDatas(this.materialShaderData._defineDatas);
            var shaderIns = pass.withCompile(comDef, true);
            this._shaderInstances.add(shaderIns);
        }
    }
    _prepare(context) {
        this.globalShaderData = this.owner && this.owner._globalShaderData;
        this._compileShader(context);
    }
    _render(context) {
        if (this._shaderInstances.length == 1) {
            this.renderByShaderInstance(this._shaderInstances.elements[0], context);
        }
        else {
            var passes = this._shaderInstances.elements;
            for (var j = 0, m = this._shaderInstances.length; j < m; j++) {
                this.renderByShaderInstance(passes[j], context);
            }
        }
    }
    _uploadGlobalAndPass(shader, context) {
        this.globalShaderData && shader.uploadUniforms(shader._cameraUniformParamsMap, this.globalShaderData, true);
        context.passData && shader.uploadUniforms(shader._sceneUniformParamsMap, context.passData, true);
    }
    renderByShaderInstance(shader, context) {
        if (!shader.complete || !this.geometry)
            return;
        shader.bind();
        this._uploadGlobalAndPass(shader, context);
        this.value2DShaderData && shader.uploadUniforms(shader._sprite2DUniformParamsMap, this.value2DShaderData, true);
        this.materialShaderData && shader.uploadUniforms(shader._materialUniformParamsMap, this.materialShaderData, true);
        if (this.renderStateIsBySprite || !this.materialShaderData) {
            shader.uploadRenderStateBlendDepth(this.value2DShaderData);
            shader.uploadRenderStateFrontFace(this.value2DShaderData, false, context.invertY);
        }
        else {
            shader.uploadRenderStateBlendDepth(this.materialShaderData);
            shader.uploadRenderStateFrontFace(this.materialShaderData, false, context.invertY);
        }
        WebGLEngine.instance.getDrawContext().drawGeometryElement(this.geometry);
    }
    destroy() {
        this.globalShaderData = null;
    }
}
WebGLRenderElement2D._compileDefine = new WebDefineDatas();
